module.exports = __webpack_public_path__ + "static/media/featured.bc071481.png";